<div *ngIf="!hasGeenAftrekItems()">
    <snelstart-venture-fiscaal-feature-spec-zorgkosten></snelstart-venture-fiscaal-feature-spec-zorgkosten>

    <snelstart-venture-fiscaal-feature-spec-giften></snelstart-venture-fiscaal-feature-spec-giften>

    <snelstart-venture-fiscaal-feature-spec-scholing></snelstart-venture-fiscaal-feature-spec-scholing>

    <snelstart-venture-fiscaal-feature-spec-overige-pga></snelstart-venture-fiscaal-feature-spec-overige-pga>


    <form [formGroup]="totaalPgaFg">
        <div>
            <div class="row">
                <div class="col col-1">
                    <p><b>Totaal persoonsgebonden aftrek</b></p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            formControlName="totaalPga"
                            id="totaalPga"
                            class="custom-input-150"
                            [decimals]="0"
                            prefix="€"
                            align="right"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-2"></div>
            </div>
        </div>
    </form>

    <div *ngIf="terugOntvangenPgaFg.get('totaalNegatievePga')?.value > 0">

        <div class="space40"></div>

        <form [formGroup]="terugOntvangenPgaFg">
            <div class="left">
                <div class="row">
                    <div class="col col-1 pt-3">
                        <p>Terugontvangen afgetrokken zorgkosten</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                formControlName="inkomstenSpecifiekeZiektekostenAangever"
                                id="inkomstenSpecifiekeZiektekosten"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                                label="{{this.dataService.naamAangever}}"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-2" *ngIf="this.aangifte && this.aangifte.partnerAangifte && this.aangifte.gezamenlijkeAangifte">
                        <snelstart-ui-number-form-control
                                formControlName="inkomstenSpecifiekeZiektekostenPartner"
                                id="inkomstenSpecifiekeZiektekostenPartner"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                                label="{{this.dataService.naamPartner}}"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div class="left">
                <div class="row">
                    <div class="col col-1">
                        <p>Terugontvangen afgetrokken giften</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                formControlName="inkomstenOverigGiftenAangever"
                                id="inkomstenOverigGiftenPartner"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-2" *ngIf="this.aangifte && this.aangifte.partnerAangifte && this.aangifte.gezamenlijkeAangifte">
                        <snelstart-ui-number-form-control
                                formControlName="inkomstenOverigGiftenPartner"
                                id="inkomstenOverigGiften"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div class="left">
                <div class="row">
                    <div class="col col-1">
                        <p>Terugontvangen afgetrokken studiekosten</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                formControlName="inkomstenOverigStudiekostenAangever"
                                id="inkomstenOverigStudiekosten"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-2" *ngIf="this.aangifte && this.aangifte.partnerAangifte && this.aangifte.gezamenlijkeAangifte">
                        <snelstart-ui-number-form-control
                                formControlName="inkomstenOverigStudiekostenPartner"
                                id="inkomstenOverigStudiekostenPartner"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div class="left">
                <div class="row">
                    <div class="col col-1">
                        <p>Terugontvangen betaalde alimentatie</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                formControlName="terugontvangenAlimentatieAangever"
                                id="terugontvangenAlimentatie"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-2" *ngIf="this.aangifte && this.aangifte.partnerAangifte && this.aangifte.gezamenlijkeAangifte">
                        <snelstart-ui-number-form-control
                                formControlName="terugontvangenAlimentatiePartner"
                                id="terugontvangenAlimentatieParatner"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
